import { fbUsersClient } from "../api/ApiClients";
import {
  GenerateAutocompleteSampleSetupCommand,
  IGenerateAutocompleteSampleSetupCommand,
  ILapsedCoachActivationCommand,
  IUpdateUserProfileCommand,
  IVerifyEmailCommand,
  LapsedCoachActivationCommand,
  UpdateUserProfileCommand,
  VerifyEmailCommand,
  UsersSort,
} from "@growth-machine-llc/stridist-api-client";
import ServiceBase from "./ServiceBase";

class FbUsersService extends ServiceBase {
  async updateUser(variables: IUpdateUserProfileCommand) {
    const command = UpdateUserProfileCommand.fromJS(variables);

    return fbUsersClient.updateUserProfile(variables.id, command);
  }

  async deleteUser(id: number) {
    return fbUsersClient.deleteUser(id);
  }

  async getCurrentUser() {
    return fbUsersClient.getUserInfo();
  }

  async verifyUserEmail(variables: IVerifyEmailCommand) {
    const command = VerifyEmailCommand.fromJS(variables);
    return fbUsersClient.verifyEmail(command);
  }

  async updatePasswordDate() {
    return fbUsersClient.updatePasswordDate();
  }

  async getAdminUsers(
    role: any,
    pageNumber: number,
    pageSize: number,
    activeSubscription: boolean = true,
    sort: UsersSort = UsersSort.LAST_ACTIVE_ASC,
    search?: string,
    archived?: boolean,
  ) {
    return fbUsersClient.adminGetUsersInfo(
      role,
      pageNumber,
      pageSize,
      activeSubscription,
      sort,
      search,
      archived,
    );
  }

  async getAdminUser(userId: number) {
    return fbUsersClient.adminGetUserInfo(userId);
  }

  async sampleSetup(variables: IGenerateAutocompleteSampleSetupCommand) {
    const command = GenerateAutocompleteSampleSetupCommand.fromJS(variables);
    return fbUsersClient.generateAutocompleteSampleSetupCommand(command);
  }

  async lapsedCoachActivation(variables: ILapsedCoachActivationCommand) {
    const command = LapsedCoachActivationCommand.fromJS(variables);
    return fbUsersClient.lapsedCoachActivation(command);
  }
}

export default new FbUsersService();
